import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { hasVerifiedSession } from "../utils/authSession";

const ProtectedRouter = () => {
  // email_verified_at in localStorage is a non-sensitive UX indicator.
  // Actual auth is enforced server-side via the httpOnly access_token cookie.
  // hasVerifiedSession() — NOT a bare truthiness check: an unverified login used
  // to leave the string "null" in that key, which is truthy.
  if (hasVerifiedSession()) {
    return <Outlet />;
  }
  return <Navigate to="/login" />;
};

const ProtectedRouterTwo = () => {
  // Redirect authenticated users away from login/signup
  if (hasVerifiedSession()) {
    return <Navigate to="/dashboard" />;
  }
  return <Outlet />;
};

const RootRedirect = () => {
  // app.popuppush.com is the product, not a marketing site — "/" never
  // renders a landing page, it just routes to the right place.
  if (hasVerifiedSession()) {
    return <Navigate to="/dashboard" />;
  }
  return <Navigate to="/login" />;
};

export { ProtectedRouter, ProtectedRouterTwo, RootRedirect };
